export default "__VITE_ASSET__5Kb6f20e__"